import React from 'react';

import CrewTimelineTable from 'pages/CrewTimeline/components/CrewTimelineTable';

import styles from './styles.module.css';

const TimelineContainer = ({
	timelineData,
	onPreviousPeriod,
	onNextPeriod,
	onToday,
	displayDays,
	canNavigatePrevious,
	canNavigateNext,
}) => {
	return (
		<div className={styles.timelineWrapper}>
			<div className={styles.timelineMainContainer}>
				<CrewTimelineTable
					timelineData={timelineData}
					displayDays={displayDays}
					onPreviousPeriod={onPreviousPeriod}
					onNextPeriod={onNextPeriod}
					onToday={onToday}
					canNavigatePrevious={canNavigatePrevious}
					canNavigateNext={canNavigateNext}
				/>
			</div>
		</div>
	);
};

export default TimelineContainer;
